import script from "./detailsHeader.vue?vue&type=script&lang=js"
export * from "./detailsHeader.vue?vue&type=script&lang=js"

import "./detailsHeader.vue?vue&type=style&index=0&id=1e32976d&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.www/src/fe-www/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e32976d"]])

export default __exports__